<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <v-card color="primary" class="card">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Observaciones</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    label="Ingrese observaciones"
                    v-model="evaluacion.detalle.observaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    no-resize
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card color="primary" class="card">
          <v-card-title>
            <div class="text-subtitle-1 font-weight-bold">Resultados</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex">
                  <span>Resultado:</span>
                  <v-spacer></v-spacer>
                  <span>
                    {{ RESULTADOS[getResultado] }}
                  </span>
                </v-col>
                <v-col cols="12" class="d-flex"
                  ><span>Puntaje total:</span>
                  <v-spacer />
                  <span>{{ getPuntajeTotal }}</span>
                </v-col>
                <v-col cols="12" class="d-flex"
                  ><span>Calificación:</span>
                  <v-spacer></v-spacer>
                  <span>{{ getCalificacion }}</span>
                </v-col>
                <v-col cols="12">
                  <BaseSelect v-model="evaluacion.detalle.status" label="Estatus" :items="estatusEvaluacionItems" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  getCalification,
  getIdResultado,
  getPuntajeTotal,
  RESULTADOS,
} from '../../../../modules/evaluacion-desempeño-academico/domain/rules/evaluation.rules'
import BaseSelect from '../../../base/BaseSelect.vue'

export default {
  components: { BaseSelect },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  async mounted() {
    await this.fetchEstatusEvaluacion()
  },

  data() {
    return {
      RESULTADOS,
    }
  },

  computed: {
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacionItems: 'getEstatusEvaluacion',
    }),

    getResultado: function () {
      return getIdResultado(this.getPuntajeTotal, this.evaluacion.tipo)
    },

    getPuntajeTotal: function () {
      return getPuntajeTotal(this.evaluacion.reactivos)
    },

    getCalificacion: function () {
      return getCalification(this.getPuntajeTotal, this.evaluacion.tipo)
    },
  },

  methods: {
    ...mapActions('estatusEvaluacion', ['fetchEstatusEvaluacion']),
  },
}
</script>
